/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteDraft.defs.js'
export * as $defs from './deleteDraft.defs.js'
